import { useContext } from 'react';
import { styled } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Button from "../../../../customs/Button";
import apiCall from "../../../../utils/apiCall";
import { NotificationContext } from '../../../../providers/notification';

interface ComponentProps {
    qualificationId: number;
    qualificationName: string;
    handleClose: () => void;
}

const DeleteQualification: React.FC<ComponentProps> = ({ qualificationId, qualificationName, handleClose}) => {
    const queryClient = useQueryClient();
    const { showNotification } = useContext(NotificationContext);

    const deleteQualification = (id: number) => {
        return apiCall().delete(`/SetUp/DeleteQualificationById?Id=${id}`);
    };

    const deleteQualificationMutation = useMutation(['delete-qualification'], deleteQualification, {retry: 0});

    const deleteQualificationHandler = async (id : number) => {
        try { 
            await deleteQualificationMutation.mutateAsync(id, {
                onSuccess: () => {
                    showNotification({
                        message: 'Qualification deleted successfully',
                        type: 'success'
                    })
                    queryClient.refetchQueries(['get-qualifications']);
                    handleClose();
                }
            })
        } catch(error: any) {
            showNotification({
                message: error?.response?.data?.title || error?.message,
                type: 'error',
            })
        }
    };

    const handleDeleteQualification = (id : number) => deleteQualificationHandler(id);

    return (
        <StyledContainer>
            <StyledText>You are about to delete <strong>{qualificationName}</strong></StyledText>
            <ButtonWrapper>
                <ButtonContainer>
                    <StyledButton onClick={handleClose} text='Cancel'/>
                    <StyledButton 
                        onClick={() => handleDeleteQualification(qualificationId)} 
                        type="submit" 
                        text={deleteQualificationMutation.isLoading ? 'Deleting' : 'Yes, Delete'}
                        disabled={deleteQualificationMutation.isLoading}
                    />
                </ButtonContainer>
            </ButtonWrapper>
        </StyledContainer>
    )
}

export default DeleteQualification;

const StyledContainer = styled('div')`
    margin-inline: 3.5rem;
    margin-block: 2.5rem;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-block: 2.5rem;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
    background-color: #DD5151;
`

const StyledText = styled('span')`
    color: #232323;
    font-size: 1.4rem;
    font-weight: 400;
`